import Vue from 'vue';
import VModal from 'vue-js-modal';
// VTooltip
import VTooltip from 'v-tooltip';
import VueCookieBot from '@ambitiondev/vue-cookiebot-plugin';

Vue.use(VModal);
Vue.use(VueCookieBot, {
  cookieBotID: process.env.APP_COOKIEBOT_ID
});
Vue.use(VTooltip);

// Register Ald Automotive components, they start with 'ald-', example: ald-accordion
Vue.component('ald-accordion', () =>
  import(/* webpackChunkName: "components/ald-accordion" */ 'components/Accordion')
);
Vue.component('ald-alert', () =>
  import(/* webpackChunkName: "components/ald-alert" */ 'components/Alert')
);
Vue.component('ald-amazon-widget', () =>
  import(/* webpackChunkName: "components/ald-amazon-widget" */ 'components/AmazonWidget')
);
Vue.component('ald-badge', () =>
  import(/* webpackChunkName: "components/ald-badge" */ 'components/Badge')
);
Vue.component('ald-button', () =>
  import(/* webpackChunkName: "components/ald-button" */ 'components/Button')
);
Vue.component('ald-button-group', () =>
  import(/* webpackChunkName: "components/ald-button-group" */ 'components/ButtonGroup')
);
Vue.component('ald-card', () =>
  import(/* webpackChunkName: "components/ald-card" */ 'components/Card')
);
Vue.component('ald-checkbox', () =>
  import(/* webpackChunkName: "components/ald-checkbox" */ 'components/Checkbox')
);
Vue.component('ald-check-list', () =>
  import(/* webpackChunkName: "components/ald-check-list" */ 'components/CheckList')
);
Vue.component('ald-collapse', () =>
  import(/* webpackChunkName: "components/ald-collapse" */ 'components/Collapse')
);
Vue.component('ald-detail', () =>
  import(/* webpackChunkName: "components/ald-detail" */ 'components/Detail')
);
Vue.component('ald-eid', () =>
  import(/* webpackChunkName: "components/ald-eid" */ 'components/ElectronicID')
);
Vue.component('ald-fineuploader', () =>
  import(/* webpackChunkName: "components/ald-fineuploader" */ 'components/Fineuploader')
);
Vue.component('ald-icon', () =>
  import(/* webpackChunkName: "components/ald-icon" */ 'components/Icon')
);
Vue.component('ald-input', () =>
  import(/* webpackChunkName: "components/ald-input" */ 'components/Input')
);
Vue.component('ald-legal-conditions', () =>
  import(/* webpackChunkName: "components/ald-legal-conditions" */ 'components/LegalConditions')
);
Vue.component('ald-loader', () =>
  import(/* webpackChunkName: "components/ald-loader" */ 'components/Loader')
);
Vue.component('ald-markdown', () =>
  import(/* webpackChunkName: "components/ald-markdown" */ 'components/Markdown')
);
Vue.component('ald-modal', () =>
  import(/* webpackChunkName: "components/ald-modal" */ 'components/Modal')
);
Vue.component('ald-radio', () =>
  import(/* webpackChunkName: "components/ald-radio" */ 'components/Radios/Radio')
);
Vue.component('ald-radios', () =>
  import(/* webpackChunkName: "components/ald-radios" */ 'components/Radios')
);
Vue.component('ald-select', () =>
  import(/* webpackChunkName: "components/ald-select" */ 'components/Select')
);
Vue.component('ald-select-filter', () =>
  import(/* webpackChunkName: "components/ald-select-filter" */ 'components/SelectFilter')
);
Vue.component('ald-stepper', () =>
  import(/* webpackChunkName: "components/ald-stepper" */ 'components/Stepper')
);
Vue.component('ald-stripe', () =>
  import(/* webpackChunkName: "components/ald-stripe" */ 'components/Stripe')
);
Vue.component('ald-text', () =>
  import(/* webpackChunkName: "components/ald-text" */ 'components/Text')
);
Vue.component('ald-transition', () =>
  import(/* webpackChunkName: "components/ald-transition" */ 'components/Transition')
);
Vue.component('ald-bank-login', () =>
  import(/* webpackChunkName: "components/ald-bank-login" */ 'components/BankLogin')
);
Vue.component('ald-file-uploader', () =>
  import(/* webpackChunkName: "components/ald-file-uploader" */ 'components/FileUploader')
);
Vue.component('ald-tool-tip', () =>
  import(/* webpackChunkName: "components/ald-tool-tip" */ 'components/ToolTip')
);
